import webBiLogger from '@wix/web-bi-logger';
export var biLogger = webBiLogger
    .factory({ endpoint: 'video-maker' })
    .updateDefaults({
    src: 84,
})
    .logger();
export function videoMakerAppPreLoad(_a) {
    var isFirst = _a.isFirst, metaSiteId = _a.metaSiteId, origin = _a.origin, sessionId = _a.sessionId, source = _a.source, context = _a.context;
    biLogger
        .log({
        evid: 200,
        isFirst: isFirst,
        msid: metaSiteId,
        origin: origin,
        sessionId: sessionId,
        source: source,
        context: context,
    })
        .catch(function (error) {
        throw new Error(error);
    });
}
//# sourceMappingURL=biLogger.js.map